// ABOUTME: App-switcher menu entry that navigates to the HProduce Suite portal.
// ABOUTME: Plain semantic link styled with Emotion ClassNames, matching the ProductSelect row look.
import {ClassNames} from '@emotion/react'
import {appUrl, suite} from '@hconnect/common/hproduce/config'
import React from 'react'

import {HeidelbergMaterialsSquareLogoComponent, dataTestId, useUikitTranslation} from '../../common'

export const HProduceSuiteLink: React.FC = () => {
  const {t} = useUikitTranslation()

  return (
    <ClassNames>
      {({css}) => (
        <a
          href={appUrl(suite.url)}
          className={css({
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            padding: 16,
            color: 'inherit',
            textDecoration: 'none',
            '&:hover': {
              background: 'rgba(0, 0, 0, 0.04)'
            }
          })}
          {...dataTestId('suite-link')}
        >
          <HeidelbergMaterialsSquareLogoComponent width={16} height={16} />
          {t('appSelect.suite', 'Suite')}
        </a>
      )}
    </ClassNames>
  )
}
